import React, { useState, useEffect } from 'react';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Regex from 'services/utils/regex/Regex';
import Loader from 'components/sales/Loader/loader';

const siteInformationInputs = {
  site_id: '',
  site_type: '',
  client_name: '',
  phone_number: '',
  second_contact: '',
  email: '',
  city_id: '',
  zone_id: '',
  area_id: '',
  pin_code: '',
  client_address: '',
};

const SiteInformationForm = ({
  isLoading = false,
  setIsLoading,
  locationCity,
  locationZone,
  locationArea,
  getSiteTypes,
  siteInformationData,
  cities = [],
  zones = [],
  areas = [],
  siteTypes = [],
  showFilter='block',
}) => {
  const [siteInfoData, setSiteInfoData] = useState(siteInformationInputs);
  const [isEmptyForm, setIsEmptyForm] = useState(true);

  useEffect(() => {
    (async () => {
      await locationCity();
      await getSiteTypes();
    })();
  }, [locationCity, getSiteTypes]);

  const onSubmitHandle = (e) => {
    e.preventDefault();
    let isValue = false;
    for (const key in siteInfoData) {
      if (siteInfoData[key]) {
        isValue = true;
      }
    }
    if (isValue) {
      setIsEmptyForm(true);
      siteInformationData(siteInfoData);
    } else setIsEmptyForm(false);
  };

  return (
    
    <form className="create-ticket-form" onSubmit={(e) => onSubmitHandle(e)}
      style={{'display':showFilter}}
    >
        <>
      <div className="row">
        <div className="col-md-3 col-sm-12">
          <ConstantInput
          label={localization.siteId}
          value={siteInfoData.site_id}
          regex={Regex.number.test(siteInfoData.site_id)}
          type="text"
          handleChange={(val) =>
            setSiteInfoData({ ...siteInfoData, site_id: val })
          }
        />
        </div>
        <div className="col-md-3 col-sm-12">
          <DropDownInput
          label={localization.siteType}
          data={siteTypes}
          getIdValue={(val) =>
            setSiteInfoData({ ...siteInfoData, site_type: val.id })
          }
        />
        </div>
        <div className="col-md-3 col-sm-12">
            <ConstantInput
            label={localization.clientName}
            value={siteInfoData.client_name}
            regex={Regex.text.test(siteInfoData.client_name)}
            type="text"
            handleChange={(val) =>
              setSiteInfoData({ ...siteInfoData, client_name: val })
            }
          />
        </div>
        <div className="col-md-3 col-sm-12">
          <ConstantInput
          label={localization.phoneNumber}
          value={siteInfoData.phone_number}
          regex={Regex.phoneNumber.test(siteInfoData.phone_number)}
          type="text"
          handleChange={(val) =>
            setSiteInfoData({ ...siteInfoData, phone_number: val })
          }
        />
        </div>
        <div className="col-md-3 col-sm-12">
          <ConstantInput
          label={localization.secondContact}
          value={siteInfoData.second_contact}
          regex={Regex.phoneNumber.test(siteInfoData.second_contact)}
          type="text"
          handleChange={(val) =>
            setSiteInfoData({ ...siteInfoData, second_contact: val })
          }
        />
        </div>
        <div className="col-md-3 col-sm-12">
          <ConstantInput
          label={localization.emailId}
          value={siteInfoData.email}
          regex={Regex.email.test(siteInfoData.email)}
          type="text"
          handleChange={(val) => setSiteInfoData({ ...siteInfoData, email: val })}
        />
        </div>
        <div className="col-md-3 col-sm-12">
          <DropDownInput
          label={localization.city}
          data={cities}
          getIdValue={async (val) => {
            if (val.id) {
              setSiteInfoData({ ...siteInfoData, city_id: val.id });
              setIsLoading(true);
              await locationZone(val.id || 0);
              setIsLoading(false);
            }
          }}
          // value={siteInfoData?.city_id}
        />
        </div>
        <div className="col-md-3 col-sm-12">
          <DropDownInput
          label={localization.zone}
          data={zones}
          getIdValue={async (val) => {
            if (val.id) {
              setIsLoading(true);
              setSiteInfoData({ ...siteInfoData, zone_id: val.id });
              await locationArea(val.id || 0);
              setIsLoading(false);
            }
          }}
          // value={siteInfoData?.zone_id}
        />
        </div>
        <div className="col-md-3 col-sm-12">
          <DropDownInput
          label={localization.area}
          data={areas}
          getIdValue={(val) =>
            setSiteInfoData({ ...siteInfoData, area_id: val.id })
          }
          // value={siteInfoData?.area_id}
        />  
        </div>
        <div className="col-md-3 col-sm-12">
          <ConstantInput
          label={localization.pinCode}
          value={siteInfoData.pin_code}
          regex={Regex.alphaNumeric.test(siteInfoData.pin_code)}
          type="text"
          handleChange={(val) =>
            setSiteInfoData({ ...siteInfoData, pin_code: val })
          }
        />
        </div>
        <div className="col-md-3 col-sm-12">
          <ConstantInput
          type="text"
          fullWidth
          label={localization.clientAddress}
          value={siteInfoData.client_address}
          regex={Regex.text.test(siteInfoData.client_address)}
          handleChange={(val) =>
            setSiteInfoData({ ...siteInfoData, client_address: val })
          }
        />
        </div>
        <div className="col-md-3 col-sm-12">
          <button className="btn btn-primary" type="submit">
            {localization.getSiteDetails}
          </button>
        </div>
      </div>
      

      {!isEmptyForm && (
        <div className="form-group full-width">
          <p className="error d-block">{localization.siteInfoError}</p>
        </div>
      )}
      
      <Loader isLoading={isLoading} />
      </>
    </form>
    
  );
 
};

export default SiteInformationForm;
